import { Component } from '@angular/core';
import { ListLayoutSingleComponent } from 'gung-list';

@Component({
  selector: 'colmec-cart-list-layout',
  templateUrl: './colmec-cart-list-layout.component.html',
  styleUrls: ['./colmec-cart-list-layout.component.scss'],
  standalone: false
})
export class ColmecCartListLayoutComponent<T> extends ListLayoutSingleComponent<T> {}
